import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Globals } from '../../utils/globals';
/** Will portal its children into a given root element */

export var Portal = function Portal(_ref) {
  var portalToSelector = _ref.portalToSelector,
      children = _ref.children,
      portalTo = _ref.portalTo;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedRootElement = _React$useState2[0],
      setSelectedRootElement = _React$useState2[1]; // the root element is not always available as a result of that query selection on the initial render, so must be assigned to a piece of state


  React.useEffect(function () {
    var _a, _b;

    if (portalToSelector) {
      var element = (_a = Globals.Document) === null || _a === void 0 ? void 0 : _a.querySelector(portalToSelector);
      setSelectedRootElement(element || undefined);
    } else if (portalTo) {
      setSelectedRootElement(portalTo);
    } else {
      setSelectedRootElement((_b = Globals.Document) === null || _b === void 0 ? void 0 : _b.body);
    }
  }, [portalTo, portalToSelector]);

  if (!selectedRootElement) {
    return null;
  }

  return ReactDOM.createPortal(children, selectedRootElement);
};